export default [
  {
    "id": "mat-enem-0257",
    "numero": 1757,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "É possível usar água ou comida para atrair as \naves e observá-las. Muitas pessoas costumam \nusar água com açúcar, por exemplo, para atrair \nbeija-flores. Mas é importante saber que, na \nhora de fazer a mistura, você deve sempre usar \numa parte de açúcar para cinco partes de água. \nAlém disso, em dias quentes, precisa trocar a \nágua de duas a três vezes, pois com o calor ela \npode fermentar e, se for ingerida pela ave, pode \ndeixá-la doente. O excesso de açúcar, ao crista-\nlizar, também pode manter o bico da ave fecha-\ndo, impedindo-a de se alimentar. Isso pode até \nmatá-la. \n \nPretende-se encher completamente um copo \ncom a mistura para atrair beija-flores. O copo \ntem formato cilíndrico, e suas medidas são 10 \ncm de altura e 4 cm de diâmetro. A quantidade \nde água que deve ser utilizada na mistura é \ncerca de:                                          \n   (utilize 𝜋 = 3) \nA) 20 mL. \nB) 24 mL. \nC) 100 mL. \nD) 120 mL \nE) 600 mL.",
    "alternativas": {
      "C": "100 mL.",
      "E": "600 mL.",
      "A": "20 mL.",
      "B": "24 mL."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 257,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0258",
    "numero": 1758,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Em um jogo disputado em uma mesa de sinuca, \nhá 16 bolas: 1 branca e 15 coloridas, as quais, \nde acordo com a coloração, valem de 1 a 15 \npontos (um valor para cada bola colorida). \n \nO jogador acerta o taco na bola branca de forma \nque esta acerte as outras, com o objetivo de \nacertar duas das quinze bolas em quaisquer \ncaçapas. Os valores dessas duas bolas são \nsomados e devem resultar em um valor escolhi-\ndo pelo jogador antes do início da jogada. \n \nArthur, Bernardo e Caio escolhem os números \n12, 17 e 22 como sendo resultados de suas \nrespectivas somas. Com essa escolha, quem \ntem a maior probabilidade de ganhar o jogo é: \n \nA) Arthur, pois a soma que escolheu é a menor. \nB) Bernardo, pois há 7 possibilidades de compor \na soma escolhida por ele, contra 4 possibilida-\ndes para a escolha de Arthur e 4 possibilidades \npara a escolha de Caio. \nC) Bernardo, pois há 7 possibilidades de com-\npor a soma escolhida por ele, contra 5 possibili-\ndades para a escolha de Arthur e 4 possibilida-\ndes para a escolha de Caio. \nD) Caio, pois há 10 possibilidades de compor a \nsoma escolhida por ele, contra 5 possibilidades \npara a escolha de Arthur e 8 possibilidades para \na escolha de Bernardo. \nE) Caio, pois a soma que escolheu é a maior.",
    "alternativas": {
      "E": "Caio, pois a soma que escolheu é a maior.",
      "A": "Arthur, pois a soma que escolheu é a menor.",
      "B": "Bernardo, pois há 7 possibilidades de compor a soma escolhida por ele, contra 4 possibilida- des para a escolha de Arthur e 4 possibilidades para a escolha de Caio.",
      "C": "Bernardo, pois há 7 possibilidades de com- por a soma escolhida por ele, contra 5 possibili- dades para a escolha de Arthur e 4 possibilida- des para a escolha de Caio."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 258,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0259",
    "numero": 1759,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A figura apresenta informações biométricas de \num homem (Duílio) e de uma mulher (Sandra) \nque estão buscando alcançar seu peso ideal a \npartir das atividades físicas (corrida). Para se \nverificar a escala de obesidade, foi desenvolvida \na fórmula que permite verificar o Índice de Mas-\nsa Corporal (IMC). Esta fórmula é apresentada \ncomo IMC = m/h2, onde m é a massa em quilo-\ngramas e h é altura em metros. \n \nO PERFIL DOS NOVOS CORREDORES \n \n \nNo quadro é apresentada a Escala de Índice de \nMassa Corporal com as respectivas categorias \nrelacionadas aos pesos. \n \n \n \nA partir dos dados biométricos de Duílio e San-\ndra e da Escala de IMC, o valor IMC e a catego-\nria em que cada uma das pessoas se posiciona \nna Escala são: \n \nA) Duílio tem o IMC 26,7 e Sandra tem o IMC \n26,6, estando ambos na categoria de sobrepe-\nso. \nB) Duílio tem o IMC 27,3 e Sandra tem o IMC \n29,1, estando ambos na categoria de sobrepe-\nso. \nC) Duílio tem o IMC 27,3 e Sandra tem o IMC \n26,6, estando ambos na categoria de sobrepe-\nso. \nD) Duílio tem o IMC 25,6, estando na categoria \nde sobrepeso, e Sandra tem o IMC 24,7, estan-\ndo na categoria de peso normal. \nE) Duílio tem o IMC 25,1, estando na categoria \nde sobrepeso, e Sandra tem o IMC 22,6, estan-\ndo na categoria de peso normal.",
    "alternativas": {
      "B": "Duílio tem o IMC 27,3 e Sandra tem o IMC 29,1, estando ambos na categoria de sobrepe- so.",
      "C": "Duílio tem o IMC 27,3 e Sandra tem o IMC 26,6, estando ambos na categoria de sobrepe- so.",
      "D": "Duílio tem o IMC 25,6, estando na categoria de sobrepeso, e Sandra tem o IMC 24,7, estan- do na categoria de peso normal.",
      "A": "Duílio tem o IMC 26,7 e Sandra tem o IMC 26,6, estando ambos na categoria de sobrepe- so."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 259,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0260",
    "numero": 1760,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Todo o país passa pela primeira fase de cam-\npanha de vacinação contra a gripe suína \n(H1N1). Segundo um médico infectologista do \nInstituto Emílio Ribas, de São Paulo, a imuniza-\nção “deve mudar”, no país, a história da epide-\nmia. Com a vacina, de acordo com ele, o Brasil \ntem a chance de barrar uma tendência do cres-\ncimento da doença, que já matou 17 mil no \nmundo. A tabela apresenta dados específicos \nde um único posto de vacinação. \n \n \n \nEscolhendo-se aleatoriamente uma pessoa \natendida nesse posto de vacinação, a probabili-\ndade de ela ser portadora de doença crônica é: \n \nA) 8%. \nB) 9%. \nC) 11%. \nD) 12%. \nE) 22%.",
    "alternativas": {
      "D": "12%.",
      "E": "22%.",
      "B": "9%.",
      "C": "11%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 260,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0261",
    "numero": 1761,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O gráfico mostra a velocidade de conexão à internet utilizada em domicílios no Brasil. Esses dados são \nresultado da mais recente pesquisa, de 2009, realizada pelo Comitê Gestor da Internet (CGI). \nEscolhendo-se, aleatoriamente, um domicílio \npesquisado, qual a chance de haver banda lar-\nga de conexão de pelo menos 1 Mbps neste \ndomicílio? \n \nA) 0,45 \nB) 0,42 \nC) 0,30 \nD) 0,22 \nE) 0,15",
    "alternativas": {
      "D": "0,22",
      "E": "0,15",
      "A": "0,45",
      "C": "0,30"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 261,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0262",
    "numero": 1762,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Um técnico em refrigeração precisa revisar to-\ndos os pontos de saída de ar de um escritório \ncom várias salas. Na imagem apresentada, \ncada ponto indicado por uma letra é a saída do \nar, e os segmentos são as tubulações. \n \n \n \nIniciando a revisão pelo ponto K e terminando \nem F, sem passar mais de uma vez por cada \nponto, o caminho será passando pelos pontos: \n \nA) K, I e F. \nB) K, J, I, G, L e F. \nC) K, L, G, I, J, H e F. \nD) K, J, H, I, G, L e F. \nE) K, L, G, I, H, J e F.",
    "alternativas": {
      "E": "K, L, G, I, H, J e F.",
      "A": "K, I e F.",
      "B": "K, J, I, G, L e F.",
      "C": "K, L, G, I, J, H e F."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 262,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0263",
    "numero": 1763,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O termo agronegócio não se refere apenas à agricultura e à pecuária, pois as atividades ligadas a essa \nprodução incluem fornecedores de equipamentos, serviços para a zona rural, industrialização e comerci-\nalização dos produtos. O gráfico seguinte mostra a participação percentual do agronegócio no PIB brasileiro: \n \n \n \nEsse gráfico foi usado em uma palestra na qual o orador ressaltou uma queda da participação do agro-\nnegócio no PIB brasileiro e a posterior recuperação dessa participação, em termos percentuais. Segundo \no gráfico, o período de queda ocorreu entre os anos de: \n \nA) 1998 e 2001. \nB) 2001 e 2003. \nC) 2003 e 2006. \nD) 2003 e 2007. \nE) 2003 e 2008.",
    "alternativas": {
      "A": "1998 e 2001.",
      "B": "2001 e 2003.",
      "C": "2003 e 2006.",
      "E": "2003 e 2008."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 263,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0264",
    "numero": 1764,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "O setor de recursos humanos de uma empresa \nvai realizar uma entrevista com 120 candidatos \na uma vaga de contador. Por sorteio, eles pre-\ntendem atribuir a cada candidato um número, \ncolocar a lista de números em ordem numérica \ncrescente e usá-la para convocar os interessa-\ndos. Acontece que, por um defeito do computa-\ndor, foram gerados números com 5 algarismos \ndistintos e, em nenhum deles, apareceram dígi-\ntos pares. Em razão disso, a ordem de chamada \ndo candidato que tiver recebido o número 75913 \né: \n \nA) 24 \nB) 31 \nC) 32 \nD) 88 \nE) 89",
    "alternativas": {
      "B": "31",
      "C": "32",
      "D": "88",
      "E": "89"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 264,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0265",
    "numero": 1765,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Uma enquete, realizada em março de 2010, \nperguntava aos internautas se eles acreditavam \nque as atividades humanas provocam o aque-\ncimento global. Eram três as alternativas possí-\nveis e 279 internautas responderam à enquete, \ncomo mostra o gráfico. \n \n \n \nAnalisando os dados do gráfico, quantos inter-\nnautas responderam “NÃO” à enquete? \n \nA) Menos de 23. \nB) Mais de 23 e menos de 25. \nC) Mais de 50 e menos de 75. \nD) Mais de 100 e menos de 190. \nE) Mais de 200.",
    "alternativas": {
      "E": "Mais de 200.",
      "B": "Mais de 23 e menos de 25.",
      "C": "Mais de 50 e menos de 75.",
      "D": "Mais de 100 e menos de 190."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 265,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0266",
    "numero": 1766,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A cor de uma estrela tem relação com a tempe-\nratura em sua superfície. Estrelas não muito \nquentes (cerca de 3 000 K) nos parecem aver-\nmelhadas. Já as estrelas amarelas, como o Sol, \npossuem temperatura em torno dos 6 000 K; as \nmais quentes são brancas ou azuis porque sua \ntemperatura fica acima dos 10 000 K. \n \nA tabela apresenta uma classificação espectral \ne outros dados para as estrelas dessas classes. \n \nEstrelas da Sequência Principal \n \nTemperatura em Kelvin. \nLuminosidade, massa e raio,  \ntomando o Sol como unidade. \n \nSe tomarmos uma estrela que tenha temperatu-\nra 5 vezes maior que a temperatura do Sol, qual \nserá a ordem de grandeza de sua luminosida-\nde? \n \nA) 20 000 vezes a luminosidade do Sol. \nB) 28 000 vezes a luminosidade do Sol. \nC) 28 850 vezes a luminosidade do Sol. \nD) 30 000 vezes a luminosidade do Sol. \nE) 50 000 vezes a luminosidade do Sol.",
    "alternativas": {
      "C": "28 850 vezes a luminosidade do Sol.",
      "D": "30 000 vezes a luminosidade do Sol.",
      "E": "50 000 vezes a luminosidade do Sol.",
      "A": "20 000 vezes a luminosidade do Sol."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 266,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0267",
    "numero": 1767,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Considere que uma pessoa decida investir uma \ndeterminada quantia e que lhe sejam apresen-\ntadas possibilidades de investimento, com ren-\ntabilidades líquidas garantidas pelo período de \num ano, conforme descritas: \n \nInvestimento A: 3% ao mês \nInvestimento B: 36% ao ano \nInvestimento C: 18% ao semestre \n \nAs rentabilidades, para esses investimentos, \nincidem sobre o valor do período anterior. O \nquadro fornece algumas aproximações para a \nanálise das rentabilidades: \n \n \n \nPara escolher o investimento com a maior ren-\ntabilidade anual, essa pessoa deverá; \n \nA) escolher qualquer um dos investimentos A, B \nou C, pois as suas rentabilidades anuais são \niguais a 36%. \nB) escolher os investimentos A ou C, pois suas \nrentabilidades anuais são iguais a 39%. \nC) escolher o investimento A, pois a sua rentabi-\nlidade anual é maior que as rentabilidades anu-\nais dos investimentos B e C. \nD) escolher o investimento B, pois sua rentabilida-\nde de 36% é maior que as rentabilidades de 3% do \ninvestimento A e de 18% do investimento C. \nE) escolher o investimento C, pois sua rentabili-\ndade de 39% ao ano é maior que a rentabilida-\nde de 36% ao ano dos investimentos A e B.",
    "alternativas": {
      "A": "escolher qualquer um dos investimentos A, B ou C, pois as suas rentabilidades anuais são iguais a 36%.",
      "B": "escolher os investimentos A ou C, pois suas rentabilidades anuais são iguais a 39%.",
      "C": "escolher o investimento A, pois a sua rentabi- lidade anual é maior que as rentabilidades anu- ais dos investimentos B e C.",
      "E": "escolher o investimento C, pois sua rentabili- dade de 39% ao ano é maior que a rentabilida- de de 36% ao ano dos investimentos A e B."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 267,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0268",
    "numero": 1768,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "A resistência das vigas de dado comprimento é \ndiretamente proporcional à largura (b) e ao qua-\ndrado da altura (d), conforme a figura. A cons-\ntante de proporcionalidade k varia de acordo \ncom o material utilizado na sua construção. \n \n \n \nConsiderando-se S como a resistência, a repre-\nsentação algébrica que exprime essa relação é: \nA) S = k . b .d \n \nB) S = b . d2 \n \nC) S = k . b . d2  \n \nD) S = \nk .  b\nd2  \n \nE) S = \nk .  d\nb2",
    "alternativas": {
      "B": "S = b . d2",
      "C": "S = k . b . d2",
      "E": "S = k . d b2",
      "A": "S = k . b .d"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 268,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0270",
    "numero": 1770,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Uma indústria fabrica um único tipo de produto e \nsempre vende tudo o que produz. O custo total \npara fabricar uma quantidade q de produtos é \ndado por uma função, simbolizada por CT, en-\nquanto o faturamento que a empresa obtém \ncom a venda da quantidade q também é uma \nfunção, simbolizada por FT. O lucro total (LT) \nobtido pela venda da quantidade q de produtos \né dado pela expressão LT(q) = FT(q) – CT(q). \n \nConsiderando-se as funções FT(q) = 5q e   \nCT(q) = 2q + 12 como faturamento e custo, qual \na quantidade mínima de produtos que a indús-\ntria terá de fabricar para não ter prejuízo? \n \nA) 0 \nB) 1 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "E": "5",
      "B": "1",
      "C": "3",
      "D": "4"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.1",
    "numeroOriginal": 270,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0271",
    "numero": 1771,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Considere que o esquema represente uma trilha \npoligonal que Carlos deve percorrer, partindo do \nponto A até chegar ao ponto M. \nSabendo que o segmento AB possui 11 m de \ncomprimento e, a partir desse, o comprimento \nde cada segmento seguinte possui um metro a \nmenos que o comprimento do segmento anteri-\nor, quantos metros Carlos terá caminhado ao \npercorrer toda a trilha? \n \nA) 176 \nB) 121 \nC) 111 \nD) 66 \nE) 65",
    "alternativas": {
      "A": "176",
      "C": "111",
      "D": "66",
      "E": "65"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 271,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0272",
    "numero": 1772,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma campanha de vacinação contra um tipo \nespecífico de vírus, que causa uma gripe com \nalto índice de mortalidade, deverá ser realizada \nem uma cidade que tem uma população de 186 \n000 habitantes. A Secretaria de Saúde do muni-\ncípio tem os dados que evidenciam os grupos \nde pessoas mais afetadas pela doença e pre-\ntende estabelecer como critério de prioridade de \nvacinação as porcentagens de casos de morte, \nem decorrência da contaminação pelo vírus, em \nordem decrescente. Observe os dados na tabela: \n \nNúmero de pessoas que foram contaminadas pelo \nvírus, curadas e mortas, discriminadas por  \ngrupos característicos \n \n \nTomando como base os dados da tabela, os \nespecialistas em saúde pública do município \npodem verificar que o grupo com maior priorida-\nde de vacinação é o de: \n \nA) crianças entre 3 e 10 anos, porque a porcen-\ntagem de mortos é a de maior valor em relação \naos outros grupos. \nB) idosos com idade entre 60 e 80 anos, pois foi \no grupo que registrou o maior número de casos \nde pessoas contaminadas pelo vírus. \nC) mulheres gestantes, porque a porcentagem \nde curadas é de 75%. \nD) recém-nascidos, porque eles têm uma maior \nexpectativa de vida. \nE) pessoas com alto nível de obesidade, pois \nsão do grupo com maior risco de doenças.",
    "alternativas": {
      "E": "pessoas com alto nível de obesidade, pois são do grupo com maior risco de doenças.",
      "A": "crianças entre 3 e 10 anos, porque a porcen- tagem de mortos é a de maior valor em relação aos outros grupos.",
      "B": "idosos com idade entre 60 e 80 anos, pois foi o grupo que registrou o maior número de casos de pessoas contaminadas pelo vírus.",
      "D": "recém-nascidos, porque eles têm uma maior expectativa de vida."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 272,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0273",
    "numero": 1773,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "O Sr. José compra água do vizinho para irrigar \nsua plantação, situada em um terreno na forma \nde um quadrado de 30 m de lado. Ele paga R$ \n100,00 mensais pela água que consome. A \nágua é levada a seu terreno através de tubos \nem forma de cilindros de 1/2 polegada de diâ-\nmetro. \n \nVisando expandir sua plantação, o Sr. José \nadquire um terreno com o mesmo formato que o \nseu, passando a possuir um terreno em forma \nretangular, com 30 m de comprimento e 60 m \nde largura.  \n \nQuanto ele deve pagar a seu vizinho por mês, \npela água que passará a consumir? \n \nA) R$ 100,00 \nB) R$ 180,00 \nC) R$ 200,00 \nD) R$ 240,00 \nE) R$ 300,00",
    "alternativas": {
      "C": "R$ 200,00",
      "E": "R$ 300,00",
      "A": "R$ 100,00",
      "B": "R$ 180,00"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 273,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0274",
    "numero": 1774,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Durante o século XX, a principal fonte primária de geração de energia, isto é, a principal fonte de energia \ndo Brasil, foi alterada. Veja no gráfico, em termos percentuais, a quantidade de energia gerada a partir \nde cada uma das fontes primárias: \nCom base no gráfico, essa troca da principal fonte primária de geração de energia ocorreu entre quais \nfontes? \n \nA) Do carvão para a energia nuclear. \nB) Do carvão para o petróleo. \nC) Da lenha para a energia nuclear. \nD) Da lenha para o petróleo. \nE) Da lenha para o carvão.",
    "alternativas": {
      "C": "Da lenha para a energia nuclear.",
      "D": "Da lenha para o petróleo.",
      "A": "Do carvão para a energia nuclear.",
      "B": "Do carvão para o petróleo."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 274,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0275",
    "numero": 1775,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um aventureiro chama a atenção para o impac-\nto do plástico no meio ambiente, atravessando a \nmaior concentração de lixo do mundo em um \nveleiro feito totalmente de recipientes reciclá-\nveis. O barco flutua graças a 12 mil garrafas \nplásticas. No Brasil, a produção mensal de gar-\nrafas plásticas é de 9 bilhões de unidades, sen-\ndo que 47% dessas garrafas são reaproveitadas \ne o restante vai para o lixo.  \n \nQuantos barcos como esse é possível construir \ncom as garrafas que vão para o lixo no Brasil? \n \nA) 352500. \nB) 397500. \nC) 750000. \nD) 35250000. \nE) 39750000.",
    "alternativas": {
      "D": "35250000.",
      "E": "39750000.",
      "B": "397500.",
      "C": "750000."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 275,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0276",
    "numero": 1776,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Os alunos da 3ª série do ensino médio da esco-\nla Z fizeram dois simulados de matemática, \ncada um com 8 questões de múltipla escolha, \nno valor de 0,5 ponto cada. Há apenas uma \nalternativa correta por questão. O quadro mos-\ntra o percentual de alunos que acertaram cada \nquestão, em cada um dos simulados. \n \n \n \nSabendo-se que o número de alunos que fize-\nram os simulados foi o mesmo, a média geral da \nturma, considerando as notas dos dois simula-\ndos, mais aproximada, é de, \n \nA) 7,4.  \nB) 3,7.  \nC) 3,4.  \nD) 1,9.  \nE) 1,7.",
    "alternativas": {
      "A": "7,4.",
      "C": "3,4.",
      "D": "1,9.",
      "E": "1,7."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 276,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0277",
    "numero": 1777,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Atualmente existem muitos aplicativos de fa-\nzendas virtuais que, apesar de críticas, possu-\nem uma enorme quantidade de usuários. Embo-\nra apresentem algumas diferenças de funcio-\nnamento, as fazendas virtuais possuem a mes-\nma concepção: cada vez que o usuário cuida de \nsua fazenda ou da de seus amigos, ganha pon-\ntos, e, quanto mais pontos acumula, maior é seu \nnível de experiência. \n \nEm um aplicativo de fazenda virtual, o usuário \nprecisa de 1 000 pontos para atingir o nível 1. \nAcumulando mais 1 200 pontos, atinge o nível \n2; acumulando mais 1 400 pontos, atinge o nível \n3 e assim por diante, sempre com esse padrão. \n \nUm usuário que está no nível 15 de experiência \nacumulou: \n \nA) 3800 pontos. \nB) 15200 pontos. \nC) 32200 pontos. \nD) 35000 pontos. \nE) 36000 pontos.",
    "alternativas": {
      "B": "15200 pontos.",
      "D": "35000 pontos.",
      "E": "36000 pontos.",
      "A": "3800 pontos."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 277,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0278",
    "numero": 1778,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um programador visual deseja modificar uma \nimagem, aumentando seu comprimento e man-\ntendo sua largura. As figuras 1 e 2 representam, \nrespectivamente, a imagem original e a trans-\nformada pela duplicação do comprimento. \n \n \n \nPara modelar todas as possibilidades de trans-\nformação no comprimento dessa imagem, o \nprogramador precisa descobrir os padrões de \ntodas as retas que contêm os segmentos que \ncontornam os olhos, o nariz e a boca e, em se-\nguida, elaborar o programa.  \n \nNo exemplo anterior, o segmento A1B1 da figura \n1, contido na reta r1, transformou-se no segmen-\nto A2B2 da figura 2, contido na reta r2. \nSuponha que, mantendo constante a largura da \nimagem, seu comprimento seja multiplicado por \nn, sendo n um número inteiro e positivo, e que, \ndessa forma, a reta r1 sofra as mesmas trans-\nformações. Nessas condições, o segmento AnBn \nestará contido na reta rn. \n \nA equação algébrica que descreve rn, no plano \ncartesiano, é: \n \nA) x + ny = 3n. \nB) x − ny = − n. \nC) x − ny = 3n. \nD) nx + ny = 3n. \nE) nx + 2ny = 6n.",
    "alternativas": {
      "B": "x − ny = − n.",
      "C": "x − ny = 3n.",
      "E": "nx + 2ny = 6n.",
      "A": "x + ny = 3n."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 278,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0279",
    "numero": 1779,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "A figura que segue é formada por 5 quadrados \ncongruentes, cuja medida do lado é L, e um \nquadrado ABCD com vértices em um único vér-\ntice de quatro dos cinco quadrados. \n \n \n \nA área do quadrado ABCD é equivalente à área \nde um retângulo de lados: \n \nA) 2L e 3L. \nB) 3L e 1L. \nC) 3L e 3L. \nD) 4L e 1L. \nE) 5L e 1L.",
    "alternativas": {
      "E": "5L e 1L.",
      "B": "3L e 1L.",
      "C": "3L e 3L.",
      "D": "4L e 1L."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 279,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0280",
    "numero": 1780,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Pedro ganhou R$ 360 000,00 em uma loteria \nfederal e resolveu dividir integralmente o prêmio \nentre os seus três filhos, Ana, Renato e Carlos, \nde forma que cada um receba uma quantia que \nseja inversamente proporcional às suas idades. \n \nSabendo que Ana tem 4 anos, Renato, 5 anos e \nCarlos, 20 anos, eles receberão, respectivamen-\nte, \n \nA) R$ 54000,00; R$ 216000,00 e R$ 90000,00. \nB) R$ 90000,00; R$ 54000,00 e R$ 216000,00. \nC) R$ 216000,00; R$ 90 000,00 e R$ 54 000,00. \nD) R$ 180000,00; R$ 144000,00 e R$ 36000,00. \nE) R$ 180000,00; R$ 120000,00 e R$ 60000,00.",
    "alternativas": {
      "C": "R$ 216000,00; R$ 90 000,00 e R$ 54 000,00.",
      "D": "R$ 180000,00; R$ 144000,00 e R$ 36000,00.",
      "E": "R$ 180000,00; R$ 120000,00 e R$ 60000,00.",
      "B": "R$ 90000,00; R$ 54000,00 e R$ 216000,00."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 280,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0281",
    "numero": 1781,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma empresa responsável por produzir arranjos \nde parafina recebeu uma encomenda de arran-\njos em formato de cone reto. Porém, teve difi-\nculdades em receber de seu fornecedor o molde \na ser utilizado e negociou com a pessoa que fez \na encomenda o uso de arranjos na forma de um \nprisma reto, com base quadrada de dimensões \n5 cm × 5 cm. \n \nConsiderando que o arranjo na forma de cone \nutilizava um volume de 500 mL, qual deverá ser \na altura, em cm, desse prisma para que a em-\npresa gaste a mesma quantidade de parafina \nutilizada no cone? \n \nA) 8 \nB) 14 \nC) 20 \nD) 60 \nE) 200",
    "alternativas": {
      "E": "200",
      "A": "8",
      "C": "20",
      "D": "60"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 281,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0282",
    "numero": 1782,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Por falta de tratamentos simples, mais de 1 \nbilhão de pessoas pobres no mundo acordam \ndoentes todos os dias. Entre essas doenças \nestá a ancilostomose, que aflige 600 milhões de \npessoas e causa anemia severa e desnutrição \nproteica. Para fornecer tratamento a essas pes-\nsoas, estima-se um gasto anual de cinquenta \ncentavos de dólar por paciente. \n \nUma organização está disposta a lançar uma \ncampanha internacional a fim de obter recursos \nsuficientes para cobrir o tratamento das pessoas \ncom ancilostomose por um ano. Segundo seu \nplanejamento, estima-se um valor médio de \nUS$ 3,00 por doador. \n \nDe acordo com o planejamento dessa organiza-\nção, para arrecadar o total de recursos necessá-\nrios para cobrir o tratamento das pessoas com \nancilostomose, por um ano, o número mínimo \nde contribuintes necessários é de: \n \nA) 200 milhões. \nB) 120 milhões. \nC) 36 milhões. \nD) 40 milhões. \nE) 100 milhões.",
    "alternativas": {
      "D": "40 milhões.",
      "E": "100 milhões.",
      "A": "200 milhões.",
      "B": "120 milhões."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 282,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0283",
    "numero": 1783,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma agência de viagens de São Paulo (SP) \nestá organizando um pacote turístico com desti-\nno à cidade de Foz do Iguaçu (PR) e fretou um \navião com 120 lugares. Do total de lugares, \nreservou 2/5 das vagas para as pessoas que \nresidem na capital do estado de São Paulo, 3/8 \npara as que moram no interior desse estado e o \nrestante para as que residem fora dele. \nQuantas vagas estão reservadas no avião para \nas pessoas que moram fora do estado de São \nPaulo? \n \nA) 27 \nB) 40 \nC) 45 \nD) 74 \nE) 81",
    "alternativas": {
      "C": "45",
      "E": "81",
      "A": "27",
      "B": "40"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 283,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0284",
    "numero": 1784,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Em 2009, o Estado de São Paulo perdeu 3 \n205,7 hectares de sua cobertura vegetal, área \n30% menor que a desmatada em 2008, segun-\ndo balanço do projeto ambiental estratégico \n“Desmatamento Zero”, divulgado pela Secreta-\nria do Meio Ambiente (SMA). \n \nUm hectare é uma unidade de medida de área \nequivalente a 100 ares. Um are, por sua vez, é \nequivalente a 100 m². Logo, a área 3 205,7 hec-\ntares corresponde a: \n \nA) 3 205,7 × 10-1 m². \nB) 3 205,7 × 10 m². \nC) 3 205,7 × 102 m². \nD) 3 205,7 × 103 m². \nE) 3 205,7 × 104 m².",
    "alternativas": {
      "B": "3 205,7 × 10 m².",
      "C": "3 205,7 × 102 m².",
      "D": "3 205,7 × 103 m².",
      "E": "3 205,7 × 104 m²."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 284,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0285",
    "numero": 1785,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Em uma sala de aula, três alunos resolveram \nfazer uma brincadeira de medição. Cada um \nescolheu um objeto próprio para medir o com-\nprimento da lousa. O primeiro foi até a lousa e, \nusando o comprimento de um livro, verificou que \nera possível enfileirar 13 deles e ainda sobrava \num pequeno espaço igual à metade do compri-\nmento do livro. O segundo pegou seu lápis e \ncomeçou a medir a lousa. No final, percebeu \nque esse comprimento era igual a 20 lápis. O \nterceiro, para economizar tempo, pegou uma \nrégua graduada e mediu o comprimento do livro \nque o colega havia usado, obtendo 28 cm. \n \nCom base nessas informações, qual é a medida \nmais aproximada do comprimento do lápis? \n \nA) 10 cm \nB) 18 cm \nC) 19 cm \nD) 26 cm \nE) 41 cm",
    "alternativas": {
      "E": "41 cm",
      "B": "18 cm",
      "C": "19 cm",
      "D": "26 cm"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 285,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0286",
    "numero": 1786,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma universidade decidiu promover uma coleta \nde informações que fornecesse dados para \nimplementar ações destinadas à recuperação \nde estudantes que consumiam drogas no cam-\npus, cujo objetivo era reabilitar os usuários. O \nresultado dessa coleta é apresentado no qua-\ndro: \n \n \n \nA universidade tinha como objetivo que o pro-\ngrama atingisse, no mínimo, metade dos usuá-\nrios de drogas. No entanto, antes de verificar os \ndados da coleta, decidiu que abriria um grupo \nde apoio apenas para estudantes que consu-\nmissem mais de dois tipos diferentes de droga. \n \nDe acordo com as informações anteriores, a \nuniversidade atingiu seu objetivo? \n \nA) Sim, porque o grupo de apoio trabalharia \ncom 88% dos alunos envolvidos com drogas. \nB) Sim, porque o grupo de apoio trabalharia \ncom 58% dos alunos envolvidos com drogas. \nC) Não, porque o grupo de apoio trabalharia \napenas com 40% dos alunos envolvidos com \ndrogas. \nD) Não, porque o grupo de apoio trabalharia \napenas com 38% dos alunos envolvidos com \ndrogas. \nE) Não, porque o grupo de apoio trabalharia \napenas com 36% dos alunos envolvidos com \ndrogas.",
    "alternativas": {
      "C": "Não, porque o grupo de apoio trabalharia apenas com 40% dos alunos envolvidos com drogas.",
      "D": "Não, porque o grupo de apoio trabalharia apenas com 38% dos alunos envolvidos com drogas.",
      "E": "Não, porque o grupo de apoio trabalharia apenas com 36% dos alunos envolvidos com drogas.",
      "A": "Sim, porque o grupo de apoio trabalharia com 88% dos alunos envolvidos com drogas."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 286,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0287",
    "numero": 1787,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Em uma fábrica de bebidas, a máquina que \nenvasa refrigerantes é capaz de encher 150 \ngarrafas de 2 L a cada minuto e funcionar inin-\nterruptamente durante 8 horas por dia. \n \nPara atender uma encomenda de 198 000 gar-\nrafas de 2 L, a máquina é colocada para funcio-\nnar todos os dias, a partir do dia 10, sempre das \n8 h às 16 h. \n \nA máquina terminará essa tarefa no dia: \n \nA) 11, às 14 h. \nB) 12, às 14 h. \nC) 13, às 14 h. \nD) 12, às 8 h 06 min. \nE) 13, às 8 h 06 min.",
    "alternativas": {
      "B": "12, às 14 h.",
      "D": "12, às 8 h 06 min.",
      "E": "13, às 8 h 06 min.",
      "A": "11, às 14 h."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 287,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0289",
    "numero": 1789,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "No labirinto em um parque de diversões, repre-\nsentado pela malha quadriculada, encontram-se \nsete crianças: Ana, Carol, Samanta, Denise, \nRoberta, Eliana e Larissa, representadas por \npontos, identificados pela letra inicial do nome \nde cada uma delas. A malha é formada por \nquadrados, cujos lados medem 1 cm. \n \n \n \nConsidere que cada criança pode se deslocar \napenas na direção vertical ou horizontal dentro \ndo labirinto. Desse modo, Ana encontra-se \nequidistante de Samanta e de: \n \nA) Carol. \nB) Denise. \nC) Eliana. \nD) Larissa. \nE) Roberta.",
    "alternativas": {
      "D": "Larissa.",
      "A": "Carol.",
      "B": "Denise.",
      "C": "Eliana."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 289,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0290",
    "numero": 1790,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "A taxa de inflação é um índice que aponta, em \npercentuais, a evolução média dos preços de \nmercadorias e serviços. Entretanto, cada família \npercebe a variação dos preços de modo particu-\nlar, pois o peso de cada item no seu orçamento \né diferente. Assim, se o preço dos medicamen-\ntos sobe muito, o impacto da inflação para as \nfamílias que têm mais idosos tende a ser maior. \nSe o preço dos alimentos cai, o impacto da in-\nflação para as famílias mais pobres tende a ser \nmenor, já que boa parte de seu orçamento é \ngasto em alimentação. \n \nConsidere que os salários de determinado gru-\npo de pessoas crescem 10,0% ao ano, mas a \ninflação, para esse grupo, cresce 6,0% ao ano. \nO aumento percentual do poder de compra, em \ndois anos, das pessoas que pertencem ao refe-\nrido grupo, mais aproximado, será de: \n \nA) 4,0%. \nB) 7,7%. \nC) 8,0%. \nD) 8,6%. \nE) 14,0%.",
    "alternativas": {
      "C": "8,0%.",
      "D": "8,6%.",
      "E": "14,0%.",
      "B": "7,7%."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 290,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0291",
    "numero": 1791,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "A distância atual entre os centros da Terra e de \nseu satélite natural (Lua) é de 384405 km. Essa \ndistância aumenta 4 cm por ano. O centro de \ngravidade do sistema (ou baricentro), formado \npelos dois corpos celestes, está a 1737 km da \nsuperfície da Terra, e essa distância diminui \ngradativamente. Este centro de gravidade se \nlocalizará fora da Terra em 3 bilhões de anos e, \ncom isso, a Lua deixará de ser nosso satélite, \ntornando-se um planeta. \n \n \n \nQuantos centímetros por ano, em média, o cen-\ntro de gravidade do sistema se aproximará da \nsuperfície terrestre, até que a Lua se torne um \nplaneta? \n \nA) 0,0579 \nB) 0,5790 \nC) 5,7900 \nD) 12,8135 \nE) 17,2711",
    "alternativas": {
      "D": "12,8135",
      "E": "17,2711",
      "A": "0,0579",
      "C": "5,7900"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 291,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0292",
    "numero": 1792,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "A renda de uma família é de R$ 1750,00. O \ndinheiro é utilizado da seguinte maneira: \n \nAlimentação: R$ 600,00 \nSaúde: R$ 300,00 \nTransporte: R$ 150,00 \nEducação: R$ 350,00 \nLazer: R$ 200,00 \nGastos eventuais: R$ 100,00 \nPoupança: R$ 50,00 \n \nNo mês de julho, o gasto com alimentação dimi-\nnuiu 4%, o gasto com transporte aumentou 10% \ne o gasto com educação aumentou 10%. \n \nPara continuar utilizando os R$ 1750,00, o que \na família deverá decidir com relação ao valor \ndestinado à poupança, mantendo as demais \ndespesas inalteradas? \n \nA) Aumentá-lo em 4%. \nB) Aumentá-lo em 8%. \nC) Aumentá-lo em 16%. \nD) Diminuí-lo em 26%. \nE) Diminuí-lo em 52%.",
    "alternativas": {
      "A": "Aumentá-lo em 4%.",
      "B": "Aumentá-lo em 8%.",
      "D": "Diminuí-lo em 26%.",
      "E": "Diminuí-lo em 52%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 292,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0293",
    "numero": 1793,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Os medicamentos, imediatamente após a inges-\ntão, começam a ser metabolizados pelo orga-\nnismo, o que faz com que sua concentração no \nsangue diminua gradualmente, num processo \ndenominado decaimento. Denomina-se meia-\nvida de uma substância o tempo necessário \npara que o teor dessa substância no sangue se \nreduza à metade do valor inicial. \n \nConsidere a situação em que um médico pres-\ncreveu a um paciente uma dosagem de 800 mg \nde um medicamento cuja meia-vida é 6 horas, \ncom recomendação de tomar um comprimido a \ncada 12 horas, durante 3 dias. Para esse medi-\ncamento, considera-se superdosagem um teor \nsuperior a 1 520 mg, o que causa riscos de into-\nxicação. \n \nApressado em recuperar-se a tempo de ir a uma \nfesta, o paciente sugeriu ao médico que mudas-\nse a prescrição para 6 em 6 horas, imaginando \nque, assim, reduziria o tempo de tratamento. O \nmédico contra-argumentou, informando ao paci-\nente que, caso antecipasse as doses, correria o \nrisco de estar intoxicado em: \n \nA) 12 horas. \nB) 24 horas. \nC) 36 horas. \nD) 48 horas. \nE) 72 horas.",
    "alternativas": {
      "E": "72 horas.",
      "A": "12 horas.",
      "B": "24 horas.",
      "C": "36 horas."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 293,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0294",
    "numero": 1794,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "José e Antônio discutiam qual dos dois teria \nmais chances de acertar na loteria. José tinha \ngasto R$ 14,00 numa aposta de 7 números na \nMega-Sena, enquanto Antônio gastou R$ 15,00 \nem três apostas da quina, não repetindo núme-\nros em suas apostas. Na discussão, eles consi-\nderavam a chance de José acertar a quadra da \nMega-Sena e de Antônio acertar o terno da \nQuina. \n \n \nNessas condições, a razão entre as probabili-\ndades de acerto de José e de Antônio nos me-\nnores prêmios de cada loteria é: \n \nA) 261/3114, o que mostra que Antônio tem \nmais chances de acertar. \nB) 783/1038, o que mostra que Antônio tem \nmais chances de acertar. \nC) 1038/261, o que mostra que José tem mais \nchances de acertar. \nD) 3114/261, o que mostra que Antônio tem \nmais chances de acertar. \nE) 3114/261, o que mostra que José tem mais \nchances de acertar.",
    "alternativas": {
      "B": "783/1038, o que mostra que Antônio tem mais chances de acertar.",
      "C": "1038/261, o que mostra que José tem mais chances de acertar.",
      "D": "3114/261, o que mostra que Antônio tem mais chances de acertar.",
      "A": "261/3114, o que mostra que Antônio tem mais chances de acertar."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 294,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0295",
    "numero": 1795,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "O responsável por realizar uma avaliação em \numa escola convocou alguns professores para \nelaborar questões e estipulou uma meta míni-\nma. Cada professor deveria elaborar, em média, \n13 questões por dia durante uma semana. Nos \nseis primeiros dias, as quantidades de questões \nelaboradas por um professor foram 15, 12, 11, \n12, 13, 14. \n \nPara cumprir a meta mínima, a quantidade mí-\nnima de questões que o professor deverá elabo-\nrar no último dia é: \n \nA) 11. \nB) 12. \nC) 13. \nD) 14. \nE) 15.",
    "alternativas": {
      "B": "12.",
      "C": "13.",
      "D": "14.",
      "E": "15."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 295,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0296",
    "numero": 1796,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma escola tem um terreno vazio no formato \nretangular cujo perímetro é 40 m, onde se pre-\ntende realizar uma única construção que apro-\nveite o máximo de área possível. \n \nApós a análise realizada por um engenheiro, \neste concluiu que para atingir o máximo de área \ndo terreno com uma única construção, a obra \nideal seria: \n \nA) um banheiro com 8 m2. \nB) uma sala de aula com 16 m2. \nC) um auditório com 36 m2. \nD) um pátio com 100 m2. \nE) uma quadra com 160 m2.",
    "alternativas": {
      "C": "um auditório com 36 m2.",
      "D": "um pátio com 100 m2.",
      "E": "uma quadra com 160 m2.",
      "A": "um banheiro com 8 m2."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 296,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0297",
    "numero": 1797,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Observe os dados da tabela seguinte, sobre o \nnúmero de ocorrências de acidente de trabalho \nno Brasil em 2004. \n \nQuantidade de acidentes de trabalho registrados \nno Brasil por sexo, segundo os grupos  \nDe idades em 2004 \n \n \n \nO risco de acidente de trabalho de grupos de \nestudo é o resultado da probabilidade experi-\nmental calculada a partir de dados estatísticos. \nAssim sendo, considerando o disposto na tabe-\nla, qual o risco aproximado de um acidentado \nser um homem com idade entre 25 e 29 anos? \n \nA) 15% \nB) 18% \nC) 20% \nD) 78% \nE) 79%",
    "alternativas": {
      "A": "15%",
      "B": "18%",
      "D": "78%",
      "E": "79%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 297,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0298",
    "numero": 1798,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Uma cidade possui um reservatório de água C1 \nna forma de um cilindro circular reto, com 5 \nmetros de altura e capacidade para 100 m3 de \nágua. Foi construído outro reservatório C2, com \no mesmo formato do anterior, com a mesma \naltura, cujo raio da base é o dobro de C1. \n \nNessas condições, a razão entre os volumes de \nC1 e de C2 é igual a: \n \nA) 2 \nB) 1 \nC) 1/2 \nD) 1/4 \nE) 1/8",
    "alternativas": {
      "A": "2",
      "B": "1",
      "C": "1/2",
      "E": "1/8"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 298,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];